<template>
    <div class="chime-datepicker-wrapper chime-month-picker">
        <div class="chime-datepicker-header line">
            <i
                class="datepicker-btn prev-prev-btn iconfont icon-more_arrow"
                @click="updateYear(year - 1)"
            ></i>
            <p class="title">{{ year }}</p>
            <i
                class="datepicker-btn next-next-btn iconfont icon-more_arrow"
                @click="updateYear(year + 1)"
            ></i>
        </div>
        <div class="chime-datepicker-table">
            <table class="month-table" cellpadding="0" cellspacing="0">
                <tbody>
                    <tr v-for="(monthGroup, idx1) in months" :key="idx1">
                        <td
                            v-for="month in monthGroup"
                            :key="month"
                            :class="{ today: todayMonth === month }"
                            @click="chooseMonth(month)"
                        >
                            <div>
                                {{ monthSimpleNames[month] }}
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>
<script>
import { mapState } from 'pinia';
import { usePageStore } from '@/store';
export default {
    emits: ['updateYear', 'chooseMonth'],
    name: 'MonthPicker',
    props: {
        year: {
            type: Number
        },
        todayMonth: Number
    },
    data: function() {
        return {
            months: [
                [0, 1, 2, 3],
                [4, 5, 6, 7],
                [8, 9, 10, 11]
            ]
        };
    },
    computed: {
        ...mapState(usePageStore, ['monthSimpleNames'])
    },
    methods: {
        updateYear(y) {
            this.$emit('updateYear', y);
        },
        chooseMonth(month) {
            this.$emit('chooseMonth', month);
        }
    }
};
</script>
<style lang="scss">
.chime-datepicker-wrapper {
    .chime-datepicker-table {
        .month-table {
            td div {
                height: 48px;
                line-height: 36px;
                padding: 6px 0;
                box-sizing: border-box;
            }
        }
    }
}
</style>
